import { render, staticRenderFns } from "./companies.vue?vue&type=template&id=36c37fde&scoped=true&"
import script from "./companies.vue?vue&type=script&lang=js&"
export * from "./companies.vue?vue&type=script&lang=js&"
import style0 from "./companies.vue?vue&type=style&index=0&id=36c37fde&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36c37fde",
  null
  
)

export default component.exports